import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import {
  MATHQUIZ_ROUTES as MATHQUIZ_ROUTE_CONSTANTS,
  WORKSHEET_ROUTES as WORKSHEET_ROUTE_CONSTANTS,
} from '../../route-constants';

const WorksheetResumePage = lazy(
  () => import('@~/pages/worksheet/resume/worksheet-resume'),
);
const WorksheetReviewPage = lazy(
  () => import('@~/pages/worksheet/review/worksheet-review'),
);
const WorksheetPreviewPage = lazy(
  () => import('@~/pages/worksheet/preview/worksheet-preview'),
);
const SATMockTestPage = lazy(
  () => import('@~/pages/worksheet/sat-mock-test/sat-mock-test'),
);
const WorksheetDynamicPreviewPage = lazy(
  () => import('@~/pages/worksheet/preview/dynamic-worksheet-preview'),
);
const MathFitOverviewPage = lazy(() => import('@~/pages/mathfit/mathfit-overview'));
const MathQuizProgressPage = lazy(() => import('@~/pages/mathquiz/mathquiz-progress'));

export const WORKSHEET_ROUTES: RouteObject[] = [
  {
    path: WORKSHEET_ROUTE_CONSTANTS.RESUME.PATH,
    element: <WorksheetResumePage />,
    handle: {
      pageName: WORKSHEET_ROUTE_CONSTANTS.RESUME.NAME,
    },
  },
  {
    path: WORKSHEET_ROUTE_CONSTANTS.REVIEW.PATH,
    element: <WorksheetReviewPage />,
    handle: {
      pageName: WORKSHEET_ROUTE_CONSTANTS.REVIEW.NAME,
    },
  },
  {
    path: WORKSHEET_ROUTE_CONSTANTS.PREVIEW.PATH,
    element: <WorksheetPreviewPage />,
    handle: {
      pageName: WORKSHEET_ROUTE_CONSTANTS.PREVIEW.NAME,
    },
  },
  {
    path: WORKSHEET_ROUTE_CONSTANTS.DYNAMIC_PREVIEW.PATH,
    element: <WorksheetDynamicPreviewPage />,
    handle: {
      pageName: WORKSHEET_ROUTE_CONSTANTS.DYNAMIC_PREVIEW.NAME,
    },
  },
  {
    path: WORKSHEET_ROUTE_CONSTANTS.SAT_MOCK_TEST.PATH,
    element: <SATMockTestPage />,
    handle: {
      pageName: WORKSHEET_ROUTE_CONSTANTS.SAT_MOCK_TEST.NAME,
    },
  },
  {
    path: WORKSHEET_ROUTE_CONSTANTS.MATHFIT_OVERVIEW.PATH,
    element: <MathFitOverviewPage />,
    handle: {
      pageName: WORKSHEET_ROUTE_CONSTANTS.MATHFIT_OVERVIEW.NAME,
    },
  },
  {
    path: MATHQUIZ_ROUTE_CONSTANTS.PROGRESS.PATH,
    element: <MathQuizProgressPage />,
    handle: {
      pageName: MATHQUIZ_ROUTE_CONSTANTS.PROGRESS.NAME,
    },
  },
];
